<template>
  <div class="section-header">
    <v-row class="page-header__row">
      <v-col cols="12" lg="6" class="section-header__col">
        <h2 class="section-header__title">{{ title }}</h2>
        <p v-if="subtitle" class="section-header__subtitle">{{ subtitle }}</p>
      </v-col>

      <v-col cols="12" lg="6" class="section-header__col text-right">
        <slot name="action"></slot>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.section-header {
  // margin-bottom: 16px;
  &__title {
    color: $main--headers;
    font-size: 22px;
    line-height: 25px;
    font-weight: bold;
  }
  &__subtitle {
    color: $color--blue;
    font-size: 12px;
    line-height: 14px;
    font-weight: 500;
    margin-bottom: 4px;
  }
}
</style>
